var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 47C29.7326 47 35.7099 44.5241 40.117 40.117C44.5241 35.7099 47 29.7326 47 23.5C47 17.2674 44.5241 11.2901 40.117 6.88299C35.7099 2.47589 29.7326 0 23.5 0C17.2674 0 11.2901 2.47589 6.88299 6.88299C2.47589 11.2901 0 17.2674 0 23.5C0 29.7326 2.47589 35.7099 6.88299 40.117C11.2901 44.5241 17.2674 47 23.5 47ZM23.5 11.75C24.7209 11.75 25.7031 12.7322 25.7031 13.9531V24.2344C25.7031 25.4553 24.7209 26.4375 23.5 26.4375C22.2791 26.4375 21.2969 25.4553 21.2969 24.2344V13.9531C21.2969 12.7322 22.2791 11.75 23.5 11.75ZM20.5625 32.3125C20.5625 31.5334 20.872 30.7863 21.4229 30.2354C21.9738 29.6845 22.7209 29.375 23.5 29.375C24.2791 29.375 25.0262 29.6845 25.5771 30.2354C26.128 30.7863 26.4375 31.5334 26.4375 32.3125C26.4375 33.0916 26.128 33.8387 25.5771 34.3896C25.0262 34.9405 24.2791 35.25 23.5 35.25C22.7209 35.25 21.9738 34.9405 21.4229 34.3896C20.872 33.8387 20.5625 33.0916 20.5625 32.3125Z",
    fill: "#FF0000",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorProfileIcon);
export default __webpack_public_path__ + "static/media/error-profile-icon.58efa3c65e60da2d0d752315a4e4597f.svg";
export { ForwardRef as ReactComponent };